import * as React from 'react';
import { Paper, PaperProps, Stack, Theme, Typography } from '@mui/material';
import { NavLink } from 'react-router';

interface ModeButtonProps extends PaperProps {
    title: string;
    description: string;
    icon: React.ReactElement;
    disabled?: boolean;
}

const ModeButton = ({ icon, title, description, disabled, ...props }: ModeButtonProps): JSX.Element => (
    <Paper
        elevation={4}
        sx={disabled ? {} : { cursor: 'pointer', '&:hover': { background: '#ffffff20' } }}
        {...props}
        onClick={disabled ? undefined : props.onClick}
    >
        <Stack direction='row' alignItems='center' >
            {React.cloneElement(
                icon,
                {
                    fontSize: 'large',
                    sx: {
                        color: (theme: Theme) => disabled
                            ? theme.palette.text.disabled
                            : theme.palette.primary.main,
                        margin: '16px'
                    }
                }
            )}
            <Stack direction='column'
                sx={{ color: (theme) => disabled ? theme.palette.text.disabled : 'inherit' }}
            >
                <Typography variant='h6'>{title}</Typography>
                <Typography>{description}</Typography>
            </Stack>
        </Stack>
    </Paper>
)

export interface ModeLinkProps extends ModeButtonProps {
    to: string;
    state?: any;
}
export const ModeLink = ({ to, state, ...props }: ModeLinkProps): JSX.Element => (
    <NavLink style={{ textDecoration: 'none' }} to={to} state={state} >
        <ModeButton {...props} />
    </NavLink>
)

export default ModeButton;